import React from 'react';
import { Link, withRouter } from "react-router-dom"
import {Input,Form,FormGroup,Label} from "reactstrap";
const Columns = () => {
		let columns = [
			{
				id: 'salida_id',
				name: 'Salida ID',
				selector: row => row.salida_id,
				sortable: true,
				wrap: true,
			},
			{
				id: 'unidad',
				name: 'Unidad',
				selector: row => row.unidad,
				sortable: true,
				wrap: true,
			},
			{
				id: 'fechaDate',
				name: 'Fecha',
				selector: row => row.fechaDate,
				sortable: true,
				wrap: true,
			},
			{
				id: 'hora',
				name: 'Hora',
				selector: row => row.hora,
				sortable: true,
				wrap: true,
			},
			{
				id: 'velocidad',
				name: 'Velocidad (Km/h)',
				selector: row => row.velocidad,
				sortable: true,
				wrap: true,
			},
			{
				id: 'operator_name',
				name: 'Operador',
				selector: row => row.operator_name,
				sortable: true,
				wrap: true,
			},
		];
	return columns;
}

export default Columns;

//vaneton beicli